export const REMINDERS_QUERY_KEY = 'reminders'
export const REMINDERS_COUNT_QUERY_KEY = 'reminders-count'
